import { render } from "./Heading.vue?vue&type=template&id=bed98e04&scoped=true&lang=html"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"

import "./Heading.vue?vue&type=style&index=0&id=bed98e04&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed98e04"]])

export default __exports__